<script lang="ts">
import LinkList from '../LinkList/LinkList.svelte';

let { items = [] } = $props();
</script>

<div class="breadcrumb">
    <LinkList {items} />
</div>

<style lang="scss">
    @use '/src/scss/global-constants/fonts';
    @use '/src/scss/global-constants/typography';
    @use 'sass-mq/mq' as *;

    .breadcrumb {
        padding: var(--layout-breadcrumb-margin) var(--layout-pagegrid-margin);

        :global(.linklist) {
            display: flex;
            flex-wrap: wrap;
        }

        :global(li:after) {
            content: ' ';
            background: no-repeat url('/src/stories/assets/seperator.svg') center center;
            margin: 0.2rem 1rem 0;
            float: left;
            width: 0.7rem;
            height: 1.2rem;
            vertical-align: middle;
        }

        :global(li:first-child:after) {
            transform: rotate(180deg);

            @include mq($from: tablet) {
                display: none;
            }
        }

        :global(li) {
            display: none;

            @include mq($from: tablet) {
                display: block;
            }
        }

        :global(li:first-child) {
            display: block;
        }

        :global(a) {
            @include typography.nav-secondary;
            color: var(--colour-black-out);
            white-space: nowrap;
        }

        :global(a.active) {
            color: var(--colour-grey);
        }
    }
</style>
